import { Badge, Card } from '@diwata/ironvale'
import { splitCovenantTools, type CapabilityTag } from '@/lib/covenantCapabilities'

// The Covenant's tool grants drawn as the Inner/Outer capability split
// (conclave_cds_spec §4.1): context-bearing grants on one side, egress-bearing
// on the other, and a visible warning when a Covenant holds both.

function TagList({ tags }: { tags: CapabilityTag[] }) {
  return (
    <div className="cp-cap-tags">
      {tags.map((t) => (
        <span key={t.tool} className="cp-cap-tag" title={t.permissions.join(', ') || undefined}>
          {t.tool}
          {t.permissions.length > 0 && (
            <span className="cp-cap-tag-count">{t.permissions.length}</span>
          )}
        </span>
      ))}
    </div>
  )
}

export function CapabilitySplit({ tools }: { tools: Record<string, unknown> | null | undefined }) {
  const split = splitCovenantTools(tools)

  return (
    <Card>
      <div className="cp-cap-head">
        <div className="cp-label">Capabilities</div>
        {split.posture === 'inner' && <Badge variant="info">Inner</Badge>}
        {split.posture === 'outer' && <Badge variant="warning">Outer</Badge>}
        {split.posture === 'mixed' && <Badge variant="error">split violated</Badge>}
        {split.posture === 'unbound' && <Badge variant="neutral">unbound</Badge>}
      </div>

      {split.posture === 'unbound' ? (
        <p className="cp-page-subtitle">No tools granted. This familiar converses only.</p>
      ) : (
        <div className="cp-cap-columns">
          <div className="cp-cap-col cp-cap-col--inner">
            <div className="cp-cap-col-title">Inner · context</div>
            {split.context.length > 0 ? (
              <TagList tags={split.context} />
            ) : (
              <p className="cp-cap-none">none</p>
            )}
          </div>
          <div className="cp-cap-divider" aria-hidden />
          <div className="cp-cap-col cp-cap-col--outer">
            <div className="cp-cap-col-title">Outer · egress</div>
            {split.egress.length > 0 ? (
              <TagList tags={split.egress} />
            ) : (
              <p className="cp-cap-none">none</p>
            )}
          </div>
        </div>
      )}

      {split.neutral.length > 0 && (
        <div className="cp-cap-neutral">
          <div className="cp-cap-col-title">Boundary-neutral</div>
          <TagList tags={split.neutral} />
        </div>
      )}

      {split.posture === 'mixed' && (
        <p className="cp-cap-warning">
          This Covenant holds context and egress capability at once, the split the CDS
          forbids. Move one side to a separate Adept.
        </p>
      )}
    </Card>
  )
}
